<template>
  <section id="about">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="center">
            <v-col cols="12" md="7">
              <h1 class="font-weight-light display-2">Sobre</h1>
              <h1 class="font-weight-light display-1 mb-3">
                Tranquilidade nas operações
              </h1>
              <v-row>
                <v-col cols="12" class="d-flex align-center">
                  <v-img
                    src="@/assets/img/icon1.svg"
                    max-width="60px"
                    class="mr-4"
                    @load="mixpanel.track('Carregou a Sacola de $$$ - Sobre')"
                  />
                  <p class="text-justify">
                    Economia de custos com tempos menores para destravar a licença e
                    resolver casos de vistoria. Qualificação química para entender as 
                    necessidades da sua empresa. Velocidade nos trâmites.
                  </p>
                </v-col>
                <v-col cols="12" class="d-flex align-center">
                  <v-img
                    src="@/assets/img/icon2.svg"
                    max-width="60px"
                    class="mr-4"
                    @load="mixpanel.track('Carregou o Chat - Sobre')"
                  />
                  <p class="text-justify">
                    Obtenha conselhos de quem entende do assunto e sabe navegar nas
                    tecnologias requeridas para operar o Siproquim 2. Acerte as 
                    licenças que sua empresa necessita.
                  </p>
                </v-col>
                <v-col cols="12" class="d-flex align-center">
                  <v-img
                    src="@/assets/img/icon3.svg"
                    max-width="60px"
                    class="mr-4"
                    @load="mixpanel.track('Carregou o Foguete - Sobre')"
                  />
                  <p class="text-justify">
                    Evite problemas com a fiscalização da PF. Nós acompanhamos todo
                    o processo até garantir que sua empresa tenha sucesso no pleito.
                  </p>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="5" class="d-none d-md-flex">
              <v-img
                src="@/assets/img/ill1.svg"
                class="d-block ml-auto mr-auto"
                max-width="400px"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>
<script>
import { mixpanel } from "@/main";

export default {
  data() {
    return{
    mixpanel
    }
  },
}
</script>


<style scoped>
#about {
  background-color: #f4f7f5;
}
</style>
